import { render, staticRenderFns } from "./DatePickerForm.vue?vue&type=template&id=23c1810a&"
import script from "./DatePickerForm.vue?vue&type=script&lang=js&"
export * from "./DatePickerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports